import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { StoreAction } from 'store/actions';

@Injectable()
export class LoggerApi {
    public static logger(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<ApiResponse> {
        return http.post('/logger/', params.payLoad, {
            headers: buildHeaders({ apiChannel: ApiChannel.LOGGER })
        });
    }
}
ModelBase.persistMapping[StoreAction.POST_LOGGER] = LoggerApi.logger;
